export default "__VITE_ASSET__CxoKX7sy__"